import {
  SET_EDGES,
  SET_NODES,
  SET_FLOW_VISIBILITY,
  SET_SIDEBAR_TYPE,
  UPDATE_NODE_DATA,
  DELETE_NODE,
  DELETE_EDGE,
  SELECTED_NODE,
  CHANGE_NODE_TYPE,
  DELTE_SUBSEQUENT_NODES,
  UPDATE_POSITIONS,
  UPDATE_POSTION_OF_NODE,
  SET_ACTION_TYPE,
  UPDATE_AN_EDGE,
  UPDATE_A_NODE,
  UPDATE_STEP_COUNT,
  FORM_FIELDS,
  ACTION_FORM_FIELDS,
} from 'actions/automationtypes';

const INITIAL_STATE = {
  edges: [],
  nodes: [],
  flowVisibility: false,
  sidebarType: 'empty',
  selectedNode: {},
  actionType: '',
  formFields: {},
  actionFormFields: {},
};

function deleteNodeAndRelatedItems(nodeId, nodesArray, edgesArray) {
  const deletedNodeIds = new Set(); // Track deleted node ids

  function deleteNodeAndEdges(nodeId) {
    // Delete the node from nodesArray
    const nodeIndex = nodesArray.findIndex((node) => node.id === nodeId);
    if (nodeIndex > -1) {
      nodesArray.splice(nodeIndex, 1); // Remove node from nodesArray
      deletedNodeIds.add(nodeId); // Add to deletedNodeIds for tracking
    }

    // Delete edges with this nodeId as the source or target
    let edgesToDelete = edgesArray.filter(
      (edge) => edge.source === nodeId || edge.target === nodeId,
    );

    edgesToDelete.forEach((edge) => {
      const targetNodeId = edge.target;

      // Remove the edge from edgesArray
      const edgeIndex = edgesArray.findIndex((e) => e.id === edge.id);
      if (edgeIndex > -1) {
        edgesArray.splice(edgeIndex, 1);
      }

      // Recursively delete the target node and its related edges/nodes if it hasn't been deleted yet
      if (!deletedNodeIds.has(targetNodeId)) {
        deleteNodeAndEdges(targetNodeId);
      }
    });
  }

  // Start the deletion process
  deleteNodeAndEdges(nodeId);

  return { updatedNodesArray: nodesArray, updatedEdgesArray: edgesArray };
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ACTION_FORM_FIELDS:
      return {
        ...state,
        actionFormFields: { ...state.actionFormFields, ...action.payload },
      };
    case FORM_FIELDS:
      return {
        ...state,
        formFields: {...state.formFields,...action.payload},
      };
    case UPDATE_STEP_COUNT:
      const type = action.payload.type;
      const startCount = action.payload.startCount;
      let filterdCountNode;
      if (type === 'inc') {
        filterdCountNode = state.nodes.map((item) => {
          if (item.data.step > startCount && !(item.type === 'emptyNode')) {
            return { ...item, data: { ...item.data, step: item.data.step + 1 } };
          }
          return item;
        });
      } else {
        filterdCountNode = state.nodes.map((item) => {
          if (item.data.step > startCount) {
            return { ...item, data: { ...item.data, step: item.data.step - 1 } };
          }
          return item;
        });
      }

      return {
        ...state,
        nodes: filterdCountNode,
      };
    case UPDATE_A_NODE:
      const nodeData = action.payload.value;

      const nodeId = action.payload.id;
      const updaedNodes = state.nodes.map((item) => {
        if (item.id === nodeId) {
          // console.log({ ...item, ...nodeData });
          return { ...item, ...nodeData };
        }
        return { ...item };
      });
      return {
        ...state,
        nodes: updaedNodes,
      };
    case UPDATE_AN_EDGE:
      const edgeData = action.payload.value;
      const edgeId = action.payload.id;
      const updatedEdges = state.edges.map((item) => {
        if (item.id === edgeId) {
          return { ...item, ...edgeData };
        }
        return { ...item };
      });
      return {
        ...state,
        edges: updatedEdges,
      };
    case SET_ACTION_TYPE:
      const actionVal = action.payload?.optionValue?.replace(/\s/g, '_');

      return {
        ...state,
        actionType: { ...action.payload, actionName: actionVal },
      };
    case UPDATE_POSTION_OF_NODE:
      const postionOfnode = action.payload.position;
      const updatedNode = state.nodes.map((item) => {
        if (item.id === action.payload.id) {
          return { ...item, position: postionOfnode };
        } else {
          return item;
        }
      });

      return {
        ...state,
        nodes: updatedNode,
      };

    case UPDATE_POSITIONS:
      const parentId = action.payload.id;
      const childs = state.nodes.map((item) => {
        if (item.parentId === parentId && item.type === 'plusNode') {
          return {
            ...item,
            position: { ...item.position, x: item.position.x - action.payload?.moveBy },
          };
        }
        return { ...item };
      });
      return {
        ...state,
        nodes: childs,
      };
    case DELTE_SUBSEQUENT_NODES:
      const { updatedNodesArray, updatedEdgesArray } = deleteNodeAndRelatedItems(
        action.payload,
        state.nodes,
        state.edges,
      );
      const updatedNodesArraycopy = updatedNodesArray.map((item) => item);
      const updatedEdgesArraycopy = updatedEdgesArray.map((item) => item);
      return {
        ...state,
        edges: updatedEdgesArraycopy,
        nodes: updatedNodesArraycopy,
      };

    case CHANGE_NODE_TYPE:
      const changedNodes = state.nodes.map((item) => {
        if (item.id !== action.payload?.id) {
          return item;
        }
        return { ...item, type: action.payload.type };
      });
      return {
        ...state,
        nodes: changedNodes,
      };
    case SELECTED_NODE:
      return {
        ...state,
        selectedNode: action.payload,
      };
    case DELETE_NODE:
      const plus2node = state.nodes.find((item) => item?.parentId === action.payload);
      const plus2edge = state.edges.find((item) => item.source === plus2node?.id);
      const plus1edge = state.edges.find((item) => item.target === action.payload);
      const filterdNodes = state.nodes.filter((item) => {
        if (item.id === action.payload || item.id === plus2node.id) {
          return false;
        }
        return true;
      });

      let finalNodes;
      let finalEdges;
      let filterdEdge;
      if (plus2edge) {
        filterdEdge = state.edges.filter((item) => {
          if (item.source === plus2node.id || item.target === plus2node.id) {
            return false;
          }
          return true;
        });
        finalNodes = filterdNodes.map((item) => {
          if (item.id === plus2edge.target) {
            return { ...item, parentId: plus1edge.source };
          }
          return { ...item };
        });
        finalEdges = filterdEdge.map((item) => {
          if (item.target === action.payload) {
            return { ...item, target: plus2edge.target };
          }
          return { ...item };
        });
      } else {
        filterdEdge = state.edges.filter((item) => {
          if (item.source === action.payload || item.target === action.payload) {
            return false;
          }
          return true;
        });
        finalEdges = filterdEdge;
        finalNodes = filterdNodes;
      }

      return {
        ...state,
        nodes: finalNodes,
        edges: finalEdges,
      };

    case DELETE_EDGE:
      const filterdedges = state.edges.filter((item) => item.id !== action.payload);
      return {
        ...state,
        edges: filterdedges,
      };
    case UPDATE_NODE_DATA:
      const id = action.payload.id;
      const data = action.payload.data;
      const updatedNodes = state.nodes.map((item) => {
        if (item.id !== id) {
          return item;
        } else {
          return { ...item, data: data };
        }
      });

      return {
        ...state,
        nodes: updatedNodes,
      };
    case SET_SIDEBAR_TYPE:
      return {
        ...state,
        sidebarType: action.payload,
      };
    case SET_FLOW_VISIBILITY:
      return {
        ...state,
        flowVisibility: action.payload,
      };
    case SET_EDGES:
      return {
        ...state,
        edges: action.payload,
      };
    case SET_NODES:
      return {
        ...state,
        nodes: action.payload,
      };
    default:
      return state;
  }
};

const json = {
  trigger: 'lead_creation',
  steps: [
    {
      id: 'step_1',
      type: 'condition',
      logical_operator: 'or',
      conditions: [
        {
          left_operand: 'lead_creator_email',
          comparator: 'equals',
          right_operand: 'prabhanshu@gmail.com',
        },
        {
          left_operand: 'currency',
          comparator: 'equals',
          right_operand: 'INR',
        },
        {
          left_operand: 'title',
          comparator: 'string-contains',
          right_operand: 'Test',
        },
      ],
      next_step: 'step_2',
    },
    {
      id: 'step_2',
      type: 'delay',
      duration: {
        unit: 'hours',
        value: 1,
      },
      next_step: 'step_3',
    },
    {
      id: 'step_3',
      type: 'action',
      action_type: 'create_lead_with_org',
      inputs: {
        title: 'New Lead',
        currency: 'INR',
        value: 1000,
        related_org_id: '{{relatedOrgId}}',
      },
    },
  ],
};

const json2 = [
  {
    id: 'root',
    type: 'triggerNode',
    data: {
      workaround: 'Task',
      trigger: 'Created',
      formdata: {
        title: '',
        workaround: { id: 'O1', label: 'Task' },
        trigger: { id: 'O1', label: 'Created' },
      },
      step: 1,
    },
    position: { x: 0, y: 0 },
    nodeOrigin: [0.5, 0.5],
  },
  {
    parentId: 'root',
    id: 'root_plus',
    type: 'plusNode',
    data: { parent: 'root' },
    draggable: true,
    position: { x: 250, y: 150 },
  },
  {
    parentId: 'root_plus',
    id: '1727769559908n1',
    type: 'conditionNode',
    data: {
      parent: 'root_plus',
      conditionSet1: [{ name: 'c1' }, { name: 'c2' }],
      conditionSet2: [{ name: 'c1' }],
      formValues: {
        c1: {
          fieldSelection: {
            id: 1,
            label: 'Task Title',
            type: 'text',
            condtion: [
              { id: 1, label: 'is' },
              { id: 2, label: 'is not' },
              { id: 3, label: 'contains' },
              { id: 4, label: 'does not contain' },
              { id: 5, label: 'starts with' },
              { id: 6, label: 'does not start with' },
              { id: 7, label: 'end with' },
              { id: 8, label: 'does not end with' },
              { id: 9, label: 'is empty' },
              { id: 10, label: 'is not empty' },
            ],
          },
          condition: { id: 1, label: 'is' },
          rightside: 'something',
        },
        c2: {
          fieldSelection: {
            id: 1,
            label: 'Task Title',
            type: 'text',
            condtion: [
              { id: 1, label: 'is' },
              { id: 2, label: 'is not' },
              { id: 3, label: 'contains' },
              { id: 4, label: 'does not contain' },
              { id: 5, label: 'starts with' },
              { id: 6, label: 'does not start with' },
              { id: 7, label: 'end with' },
              { id: 8, label: 'does not end with' },
              { id: 9, label: 'is empty' },
              { id: 10, label: 'is not empty' },
            ],
          },
          condition: { id: 3, label: 'contains' },
          rightside: 'something',
        },
      },
      formValues2: {
        c1: {
          fieldSelection: {
            id: 1,
            label: 'Task Title',
            type: 'text',
            condtion: [
              { id: 1, label: 'is' },
              { id: 2, label: 'is not' },
              { id: 3, label: 'contains' },
              { id: 4, label: 'does not contain' },
              { id: 5, label: 'starts with' },
              { id: 6, label: 'does not start with' },
              { id: 7, label: 'end with' },
              { id: 8, label: 'does not end with' },
              { id: 9, label: 'is empty' },
              { id: 10, label: 'is not empty' },
            ],
          },
          condition: { id: 1, label: 'is' },
          rightside: 'something',
        },
      },
      cs1Oprater: 0,
      cs2Oprater: 0,
      middleOprater: 0,
      elseRoute: false,
      step: 2,
    },
    position: { x: 16, y: 120 },
    width: 383,
    draggable: false,
  },
  {
    parentId: '1727769559908n1',
    id: '1727769559908p1',
    type: 'plusNode',
    data: { parent: '1727769559908n1' },
    position: { x: 191.5, y: 413 },
    draggable: true,
    width: 32,
  },
];
